import type { ReportType } from '@/services/admin/reports.service'

export type ReportKind = 'registered' | 'inProgress' | 'completed'

export interface ReportMeta {
  type: ReportType
  title: string
  description: string
  /** false = situação atual, ignora o período (em andamento). */
  usesPeriod: boolean
  kind: ReportKind
  /** rótulo da coluna de conteúdo (Curso / Masterclass). */
  contentLabel: string
}

export const REPORTS: ReportMeta[] = [
  {
    type: 'registered',
    title: 'Usuários cadastrados',
    description:
      'Todas as pessoas que criaram conta no período — mesmo sem ter começado nenhum curso.',
    usesPeriod: true,
    kind: 'registered',
    contentLabel: '',
  },
  {
    type: 'courses-in-progress',
    title: 'Curso em andamento',
    description:
      'Quem está com curso em andamento agora, com % concluído. Situação atual — não usa o período.',
    usesPeriod: false,
    kind: 'inProgress',
    contentLabel: 'Curso',
  },
  {
    type: 'masterclasses-in-progress',
    title: 'Masterclass em andamento',
    description:
      'Quem está com masterclass em andamento agora, com % concluído. Situação atual — não usa o período.',
    usesPeriod: false,
    kind: 'inProgress',
    contentLabel: 'Masterclass',
  },
  {
    type: 'courses-completed',
    title: 'Concluíram curso',
    description: 'Quem concluiu curso no período, com a data de conclusão.',
    usesPeriod: true,
    kind: 'completed',
    contentLabel: 'Curso',
  },
  {
    type: 'masterclasses-completed',
    title: 'Concluíram masterclass',
    description: 'Quem concluiu masterclass no período, com a data de conclusão.',
    usesPeriod: true,
    kind: 'completed',
    contentLabel: 'Masterclass',
  },
]

export const REPORT_BY_TYPE = Object.fromEntries(REPORTS.map((r) => [r.type, r])) as Record<
  ReportType,
  ReportMeta
>
